
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcPoiButtonAton as ObcPoiButtonAtonElement} from '@oicl/openbridge-webcomponents/dist/ar/poi-button-aton/poi-button-aton.js';
 
 
 

 
 export const ObcPoiButtonAton = createComponent({
   react: React,
   tagName: 'obc-poi-button-aton',
   elementClass: ObcPoiButtonAtonElement,
   events: {
     
   }
  });
 
 